<div class="know-more-lc-container page-container">
  <mat-tab-group>
    <mat-tab label="{{'wannabeartist' | translate}}">
     <div class="tab-content">
       <h1>{{'WYMKAh1' | translate}}</h1>

       <h2>{{'WYMKAh2' | translate}}</h2>
       <p>{{'WYMKAp1' | translate}}</p>

       <h2>{{'WYMKAh3' | translate}}</h2>
       <p>{{'WYMKAp2' | translate}}</p>
       <p>{{'WYMKAp3' | translate}}</p>

       <h2>{{'WYMKAh4' | translate}}</h2>
       <p>{{'WYMKAp4' | translate}}</p>
     </div>
    </mat-tab>
    <mat-tab label="{{'buyer' | translate}}">
      <div class="tab-content">
        <h1>{{'WYMKBh1' | translate}}</h1>
        <h2>{{'WYMKBh2' | translate}}</h2>
        <p>{{'whatYMKBp1' | translate}}</p>

        <h2>{{'WYMKBh3' | translate}}</h2>
        <p>{{'whatYMKBp2' | translate}}</p>
        <p>{{'whatYMKBp3' | translate}}</p>

        <h2>{{'WYMKBh4' | translate}}</h2>
        <p>{{'whatYMKBp4' | translate}}</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
